import { ConfigurationValues } from '@cutr/constants/windows/windows';

import { unboxLabel } from '../Configurations';
import { optionFilterBySystem } from '../inputs/ConfigurationSelect';
import { ConfigurationSelect } from '../inputs/ConfigurationSelect';
import { ConfigurationComponent } from '.';

const SealantInnerColorConfig = () => (
  <ConfigurationSelect
    configurationKey="sealantInnerColor"
    dispatchAction="SET_SEALANT_INNER_COLOR"
    optionsFilterFn={optionFilterBySystem}
  />
);

const config: ConfigurationComponent<'sealantInnerColor'> = {
  key: 'sealantInnerColor',
  input: <SealantInnerColorConfig />,
  display: (value: ConfigurationValues['sealantInnerColor']) => (
    <span>{unboxLabel(value.label)}</span>
  ),
};

export default config;
